import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../../../model/RootStoreContext';
import { IDistributionSearchParams } from '../../../api/requests/distribution/DistributionApiGateway';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useDistributionsCountResult {
    isLoaded: boolean;
    count: number | null;
}

export const useDistributionsCount = (searchParams: IDistributionSearchParams) => {
    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState<useDistributionsCountResult>({ isLoaded: false, count: null });

    useEffect(() => {
        setResult({ isLoaded: false, count: null });

        rootStore.distributionStore.countDistributions(searchParams)
            .then((count) => {
                setResult({ isLoaded: true, count: count });
            })
            .catch(e => publishNotification({
                text: 'Error counting distributions',
                canClose: true
            }));
    }, [rootStore.distributionStore, publishNotification, searchParams, rootStore.gameVersionStore.currentGameVersion, rootStore.gameEnvironmentsStore.currentGameEnvironment]);

    return result;
};
